import { ArrowDownRight, ArrowUpRight } from 'lucide-react'
import { formatTrend } from './format'

interface KpiCardProps {
  label: string
  /** Valeur déjà formatée (ex. « 287,50 DT », « 42 », « 4,6 »). */
  value: string
  /** Tendance vs veille en %. `null`/`undefined` → pas de flèche. */
  trendPct?: number | null
  loading?: boolean
}

/** Pastille de tendance : flèche verte (hausse) / rouge (baisse), masquée si nulle. */
function TrendBadge({ pct }: { pct: number }) {
  const positive = pct > 0
  const negative = pct < 0
  const Icon = negative ? ArrowDownRight : ArrowUpRight
  const tone = positive ? 'text-success' : negative ? 'text-danger' : 'text-muted'
  return (
    <span className={`inline-flex items-center gap-0.5 text-[13px] font-semibold ${tone}`}>
      <Icon size={15} aria-hidden />
      {formatTrend(pct)}
    </span>
  )
}

export function KpiCard({ label, value, trendPct, loading }: KpiCardProps) {
  return (
    <div className="bg-surface rounded-[18px] border border-line p-5">
      <p className="text-[13px] font-medium text-muted">{label}</p>
      {loading ? (
        <div
          data-testid="kpi-skeleton"
          className="mt-2 h-8 w-24 rounded-tile bg-line/60 animate-pulse"
        />
      ) : (
        <div className="mt-1.5 flex items-end justify-between gap-2">
          <p className="text-[28px] font-bold leading-none text-ink font-display">{value}</p>
          {trendPct !== null && trendPct !== undefined && <TrendBadge pct={trendPct} />}
        </div>
      )}
    </div>
  )
}
